import { DlmsAttributes, RecommendedRegisterDto } from "../../../../../../api/api-reference";

export type RecommendedRegisterState = 'selected' | 'missing' | 'inOtherList' | 'unavailable';

export interface RecommendedRegisterRow {
    attribute: DlmsAttributes;
    name: string | undefined;
    obis: string | undefined;
    state: RecommendedRegisterState;
    locked?: boolean;
    otherLpTitleKey?: string;
}

export interface RecommendedRegisterRowGroup {
    titleKey: string;
    rows: RecommendedRegisterRow[];
}

export function toRecommendedRegisterRow(
    register: RecommendedRegisterDto,
    state: RecommendedRegisterState,
    extra?: Partial<RecommendedRegisterRow>
): RecommendedRegisterRow {
    return { attribute: register.attribute, name: register.name, obis: register.obis, state: state, ...extra };
}
